import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useTierPerksQuery = createQueryHook(MembershipsCreatorV2ApiClient.getTierPerks, {
  queryKey: ['tierPerks'],
})
